import { Route, Routes, useLocation } from "react-router-dom";
import MainPage from "../component/mainpage/MainPage";
import DestinationPage from "../component/pages/DestinationPage";
import TopicsPage from "../component/pages/TopicsPage";
import ProgrammePage from "../component/pages/ProgrammePage";
import AuthorInstructionsPage from "../component/pages/AuthorInstructionsPage";
import VisaHelpPage from "../component/pages/VisaHelpPage";
import CalendarPage from "../component/pages/CalendarPage";
import SponsorsPage from "../component/pages/SponsorsPage";
import IvecCommitteePage from "../component/pages/IvecCommitteePage";
import EdcCommitteePage from "../component/pages/EdcCommitteePage";
import { useEffect } from "react";
import Layout from "./Layout";
import AwardPage from "../component/pages/AwardPage";
import RegistrationPage from "../component/pages/RegistrationPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppRoutes() {

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<MainPage />} />
          <Route path="/topics" element={<TopicsPage />} />
          <Route path="/programme" element={<ProgrammePage />} />
          <Route path="/calendar-section" element={<CalendarPage />} />
          <Route path="/sponsors" element={<SponsorsPage />} />
          <Route path="/registration" element={<RegistrationPage />} />
          <Route path="/author-instructions" element={<AuthorInstructionsPage />} />
          <Route path="/visa-help" element={<VisaHelpPage />} />
          <Route path="/venue-section" element={<DestinationPage />} />
          <Route path="/awards" element={<AwardPage />} />
          <Route path="/ivec" element={<IvecCommitteePage />} />
          <Route path="/edc" element={<EdcCommitteePage />} />
        </Route>
      </Routes>
    </>
  );

}
export default AppRoutes;
